import { render } from "./modal-remind-me.vue?vue&type=template&id=4e79d6f0"
import script from "./modal-remind-me.vue?vue&type=script&lang=js"
export * from "./modal-remind-me.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__